<template>
  <div>
    <el-tooltip :content="$t('accountProfileDetails.discountChange.btnTooltip')"
                effect="light"
                :open-delay="300"
                placement="bottom">
      <base-button size="md" icon round type="primary" @click="modal = true" class="zi_100">
        <span class="mdi mdi_icon mdi-24px mdi-pencil-outline"/></base-button>
    </el-tooltip>

    <modal :show.sync="modal"
           showClose
           modal-classes="modal-dialog-centered modal-lg"
           @close="resetForm()">
      <template slot="header">
        <h4 class="modal-title">
          {{ $t('accountProfileDetails.discountChange.titleText') }}
        </h4>
      </template>
      <template>
        <div class="text-center text-muted mb-4">
          <small>{{ $t('accountProfileDetails.discountChange.helpText') }}</small>
        </div>
        <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
          <!-- TODO: add error translation -->
          {{ getActionErrorDetails }}
        </base-alert>
        <form role="form" @submit.prevent="validate()">
          <div class="row">
            <label class="col-sm-3 col-form-label">{{
                $t('accountProfileDetails.discountChange.form.discountId')
              }}</label>
            <div class="col-md-9">
              <base-input
                :error="getError('discount_id')">
                <el-select
                  name="discount_id"
                  data-vv-as="'discount_id'"
                  class="select-primary"
                  v-validate="modelValidations.required"
                  v-model="formDetails.discount_id">
                  <el-option
                    v-for="option in discounts"
                    class="select-primary"
                    :value="option.id"
                    :label="option.id"
                    :key="option.id">
                  </el-option>
                </el-select>
              </base-input>
            </div>
          </div>

          <div class="row">
            <label class="col-sm-3 col-form-label">{{
                $t('accountProfileDetails.discountChange.form.changeReason')
              }}</label>
            <div class="col-md-9">
              <base-input :error="getError('changeReason')">
                <textarea class="form-control"
                          name="changeReason"
                          data-vv-as="'changeReason'"
                          :placeholder="$t('accountProfileDetails.discountChange.form.changeReasonPlaceholder')"
                          v-validate="modelValidations.required"
                          v-model="formDetails.change_reason"
                          rows="2"/>
              </base-input>
            </div>
          </div>
          <div class="text-center">
            <base-button
              type="primary"
              :loading="updating"
              class="my-4"
              native-type="submit"
            >{{ $t('accountProfileDetails.discountChange.actionBtnLabel') }}
            </base-button>
          </div>
        </form>
      </template>
    </modal>
  </div>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";

export default {
  name: 'changeAccountDiscountBtn',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  data() {
    return {
      modal: false,
      alert: false,
      loading: false,
      formDetails: {
        discount_id: '',
        change_reason: ''
      },
      modelValidations: {
        required: {
          required: true
        },
      }
    }
  },
  props: {
    accountId: {
      type: String,
      required: true
    },
  },
  computed: {
    ...mapState({
      updating: state => state.account.updating,
      error: state => state.account.error,
      data: state => state.account.data,
      discounts: state => state.discount.data,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    }
  },
  methods: {
    ...mapActions(['LoadDiscounts', 'UpdateAccountDiscount', 'LoadAccountDiscounts', 'LoadAccountAuditLogs']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate: function () {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.create()
        }
      });
    },
    create: function () {
      this.UpdateAccountDiscount({id: this.accountId, data: this.formDetails}).then(() => {
        if (this.error != null) {
          this.alert = true
          // got error, don't reset form
        } else {
          this.LoadAccountDiscounts(this.accountId)
          this.LoadAccountAuditLogs({id: this.accountId, query: {id: "", filter: "", action_result:""}})
          this.$notify({
            type: 'success',
            message: this.$t('accountProfileDetails.discountChange.createdNotification', this.formDetails),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.resetForm();
        }
      });
    },
    resetForm: function () {
      // closing dialog
      this.modal = false;

      // resetting alerts
      this.alert = false;

      // resetting form
      this.formDetails = {
        discount_id: '',
        change_reason: ''
      };

      // reset validation errors
      this.$validator.reset()
    }
  },
  mounted() {
    this.LoadDiscounts()
  },
}
</script>
